/**
 * Cut strings that are longer than the desired length, and add ellipsis to them
 * @param {string}
 * @param {number} [max=1000] Maximal length
 * @return {string}
 */
export default (str = '', max = 1e3) => str.length > max ? `${str.substr(0, max)}...` : str;
